import api from '../utils/api';

class DocumentationService {
  async getDocs(params = {}) {
    try {
      const response = await api.get('/documentation', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDocById(id) {
    try {
      const response = await api.get(`/documentation/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createDoc(formData) {
    try {
      const response = await api.post('/documentation', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateDoc(id, formData) {
    try {
      // POST mapping as PUT is handled in CodeIgniter with _method=PUT for files or custom routing
      const response = await api.post(`/documentation/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteDoc(id) {
    try {
      const response = await api.delete(`/documentation/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteAttachment(id) {
    try {
      const response = await api.delete(`/documentation/attachment/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getModules() {
    try {
      // Using the dedicated module endpoint within the documentation group
      const response = await api.get('/documentation/get-modules');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getAllModules() {
    try {
      const response = await api.get('/documentation/get-modules');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
  
  async getEmployees() {
    try {
      // Using the dedicated employee list endpoint within the documentation group
      const response = await api.get('/documentation/get-employees');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getCustomers() {
    try {
      // Using the dedicated customer list endpoint within the documentation group
      const response = await api.get('/documentation/get-customers');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getDocTypes() {
    try {
      const response = await api.get('/documentation/get-types');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async createDocType(typeName) {
    try {
      const response = await api.post('/documentation/create-type', { type_name: typeName });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updateDocType(id, typeName) {
    try {
      const response = await api.post(`/documentation/update-type/${id}`, { type_name: typeName });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async deleteDocType(id) {
    try {
      const response = await api.delete(`/documentation/delete-type/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new DocumentationService();
